import {faCircleCheck} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {Text} from '../../../../../component/text/text';

import * as styles from './empty-recommendations-list.scss';

export function EmptyRecommendationsList(): JSX.Element {
    return (
        <div className={styles.EmptyRecommendationsList}>
            <div>
                <FontAwesomeIcon className={styles.EmptyRecommendationsList_icon} icon={faCircleCheck} />
            </div>
            <div className={styles.EmptyRecommendationsList_descriptionWrapper}>
                <Text block bolder stringKey="DASHBOARD_PAGE__RECOMMENDATION__EMPTY_LIST__TITLE" />
                <Text block secondary stringKey="DASHBOARD_PAGE__RECOMMENDATION__EMPTY_LIST__DESCRIPTION" />
            </div>
        </div>
    );
}
